// extracted by mini-css-extract-plugin
export default {"icon":"OGn9H7HSHlR3gdixgj6g","small":"N9d1vleq4uF4CDCvmGPq","smaller":"bO5QoW157WcTDklC5mhg","large":"Ota8geT5G7segGmd3H3P"};